
import React from 'react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import CreateNewObject from './CreateNewObject';

const InfoHome = ({appActions}) => {

    const classNames = mergeStyleSets({
        InfoHome: {
        },
    });

    const handleToDataWindowClick = () => {
        appActions.setUiValue('activeWindow', 'data');
    }

    return (
        <Stack verticalFill className={classNames.InfoHome} tokens={{childrenGap: 4}}>
            <Stack.Item grow>
                <CreateNewObject />
            </Stack.Item>
            <Stack>
                <DefaultButton onClick={handleToDataWindowClick}>Přejít do Datového okna</DefaultButton>
            </Stack>
        </Stack>
    );
}

export default InfoHome;
